import React, { Component } from 'react'
import logo from '../assets/img/sponsor.png'
import './Header.css'

export default class Header extends Component {
  render() {
    return (
        <nav className="mt-5">
          <a href="/"><img className="brand-logo" src={logo} alt="Teni" /></a>
        </nav>
    )
  }
}
